var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSabeqoonIconColored26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.14 53.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.63,43.5h-9.27s-.73,4.69,0,6.09c.73,1.41,3.67,3.8,5.83,2.84,2.16-.96,3.23-1.22,3.44-3.07.21-1.85,0-5.86,0-5.86",
    fill: "#f2f2f2",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.74,29.04c-.69-13.19-8.89-13-11.64-13s-10.94-.19-11.64,13c-.03,3.08,2.29,6.32,3.75,7.78s3.4,3.85,2.92,6.72h9.94c-.49-2.86,1.46-5.26,2.92-6.72s3.78-4.7,3.75-7.78",
    fill: "#fcb814",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.12,9.65c-.49,0-.88-.39-.89-.88l-.04-7.88c0-.49.39-.89.88-.89h0c.49,0,.88.39.89.88l.04,7.88c0,.49-.39.89-.88.89h0Z",
    fill: "#000",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25,27.85h-8.44c-.49,0-.89-.4-.89-.88s.4-.89.89-.89h8.44c.49,0,.88.4.88.89s-.4.88-.88.88",
    fill: "#000",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43,27.85H.88c-.49,0-.88-.4-.88-.88s.4-.89.88-.89h8.54c.49,0,.88.4.88.89s-.4.88-.88.88",
    fill: "#000",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.26,16.04c-.23,0-.46-.09-.63-.27l-6-6.14c-.34-.35-.34-.91.01-1.25.35-.34.91-.34,1.25.01l6,6.14c.34.35.34.91-.01,1.25-.17.17-.4.25-.62.25",
    fill: "#000",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.98,16.04c-.22,0-.43-.08-.6-.24-.36-.33-.38-.89-.04-1.25l5.74-6.14c.33-.36.89-.38,1.25-.04.36.33.38.89.04,1.25l-5.74,6.14c-.17.19-.41.28-.65.28",
    fill: "#000",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.97,35.81c-2.77,2.46-4.19,4.61-4.21,6.4,0,.1,0,.2.01.3h-2.8v-8.28l1.97-4.11c.21-.44.03-.97-.41-1.18-.44-.21-.97-.02-1.18.42l-1.26,2.62-1.24-2.62c-.21-.44-.74-.63-1.18-.42-.44.21-.63.74-.42,1.18l1.95,4.11v8.28h-2.94c.03-1.31-.66-3.52-4.06-6.69-1.82-1.69-3.79-8.3-1.84-13.27,1.46-3.7,4.7-5.58,9.64-5.58h.16c5,0,8.27,1.93,9.71,5.74,1.9,5.02-.1,11.5-1.9,13.1M27.08,51.51c-2.62,0-3.77-1.71-4.06-2.22v-1.26c1,.37,2.5.78,4.24.78,1.2,0,2.53-.2,3.88-.74v1.21c-.29.51-1.44,2.22-4.06,2.22M31.14,44.28v1.84c-3.52,1.75-6.92.54-8.12,0v-1.84h8.12ZM38.53,22.09c-1.19-3.14-4.13-6.88-11.37-6.88h-.16c-7.15,0-10.08,3.65-11.29,6.71-2.19,5.56-.16,12.94,2.28,15.21,4.3,4.01,3.43,5.74,3.44,5.74-.01.01-.02.03-.03.04h0c-.19.22-.23.49-.15.76v5.84c0,.12.03.24.07.35.06.14,1.54,3.43,5.75,3.43s5.69-3.29,5.76-3.43c.05-.11.07-.23.07-.35v-5.75s.01-.02.02-.03c.12-.36.05-.71-.26-.94-.34-.41-.38-2.23,3.48-5.65,2.44-2.16,4.51-9.43,2.38-15.05",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabeqoonIconColored26);
export default __webpack_public_path__ + "static/media/Sabeqoon_Icon_Colored_26.51e19c7368f7fd09d7e8a1aba38e32e5.svg";
export { ForwardRef as ReactComponent };